import { Component, Input } from '@angular/core';

export enum MenuIconTypes {
  MEASURES,
  EVENTS,
  MESSAGES,
  HOME,
  MY_MEASURES,
  LOGOUT,
  HELP,
  PROFILE,
  EDOCUMENTS,
  EDIARY
}

@Component({
  selector: 'bepatient-dynamic-menu-main-icon',
  templateUrl: './main-icon.component.html',
  styleUrls: ['./main-icon.component.scss'],
  standalone: false
})
export class MainIconComponent {
  @Input() icon: MenuIconTypes;
  @Input() color: string;

  menuIconTypes = MenuIconTypes;
}
